import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../../chunks/tslib.es6.js";
import "../../../geometry.js";
import t from "../../../Graphic.js";
import r from "../../../core/Collection.js";
import s from "../../../core/Error.js";
import { HandleOwnerMixin as o } from "../../../core/HandleOwner.js";
import i from "../../../core/has.js";
import n from "../../../core/Loadable.js";
import a from "../../../core/Logger.js";
import { isSome as l, isNone as u } from "../../../core/maybe.js";
import { EsriPromiseMixin as p } from "../../../core/Promise.js";
import { open as c } from "../../../core/workers/workers.js";
import { property as d } from "../../../core/accessorSupport/decorators/property.js";
import "../../../core/arrayUtils.js";
import { ensureType as h } from "../../../core/accessorSupport/ensureType.js";
import { shared as y } from "../../../core/accessorSupport/decorators/shared.js";
import { subclass as m } from "../../../core/accessorSupport/decorators/subclass.js";
import { unapplyEditsZUnitScaling as f } from "../../../rest/query/operations/editsZScale.js";
import { applyFeatureSetZUnitScaling as g } from "../../../rest/query/operations/queryZScale.js";
import _ from "../../../rest/support/FeatureSet.js";
import j from "../../../geometry/Extent.js";
import S from "../../../geometry/Polygon.js";
import { typeKebabDictionary as b } from "../../../geometry/support/typeUtils.js";
var T = 0;
var F = a.getLogger("esri.layers.graphics.sources.MemorySource");

var G = /*#__PURE__*/function (_n$LoadableMixin) {
  _inherits(G, _n$LoadableMixin);

  var _super = _createSuper(G);

  function G(e) {
    var _this;

    _classCallCheck(this, G);

    _this = _super.call(this, e), _this._idToClientGraphic = null, _this.type = "memory";
    return _this;
  }

  _createClass(G, [{
    key: "load",
    value: function load(e) {
      var t = l(e) ? e.signal : null;
      return this.addResolvingPromise(this._startWorker(t)), Promise.resolve(this);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var e;
      null == (e = this._connection) || e.close(), this._connection = null;
    }
  }, {
    key: "workerGeometryType",
    get: function get() {
      var e;
      var t = null == (e = this.layer) ? void 0 : e.geometryType;
      return t ? this._geometryTypeRequiresClientGraphicMapping(t) ? "polygon" : t : null;
    }
  }, {
    key: "applyEdits",
    value: function applyEdits(e) {
      var _this2 = this;

      return this.load().then(function () {
        return _this2._applyEdits(e);
      });
    }
  }, {
    key: "openPorts",
    value: function openPorts() {
      var _this3 = this;

      return this.load().then(function () {
        return _this3._connection.openPorts();
      });
    }
  }, {
    key: "queryFeatures",
    value: function () {
      var _queryFeatures = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var t,
            r,
            s,
            o,
            _iterator,
            _step,
            _i,
            _e,
            _t,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                _context.next = 3;
                return this.load(t);

              case 3:
                _context.next = 5;
                return this._connection.invoke("queryFeatures", e ? e.toJSON() : null, t);

              case 5:
                r = _context.sent;
                g(e, this.layer.spatialReference, r);
                s = _.fromJSON(r);

                if (this._requiresClientGraphicMapping()) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", s);

              case 10:
                o = this.layer.objectIdField;
                _iterator = _createForOfIteratorHelper(s.features);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _i = _step.value;
                    _e = _i.attributes[o], _t = this._idToClientGraphic.get(_e);
                    _t && (_i.geometry = _t.geometry);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                return _context.abrupt("return", (s.geometryType = this.layer.geometryType, s));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function queryFeatures(_x) {
        return _queryFeatures.apply(this, arguments);
      }

      return queryFeatures;
    }()
  }, {
    key: "queryFeaturesJSON",
    value: function () {
      var _queryFeaturesJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
        var t,
            r,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

                if (!this._requiresClientGraphicMapping()) {
                  _context2.next = 3;
                  break;
                }

                throw new s("query-features-json:unsupported", "Cannot query in JSON format for client only geometry types (mesh and extent)");

              case 3:
                _context2.next = 5;
                return this.load(t);

              case 5:
                _context2.next = 7;
                return this._connection.invoke("queryFeatures", e ? e.toJSON() : null, t);

              case 7:
                r = _context2.sent;
                return _context2.abrupt("return", (g(e, this.layer.spatialReference, r), r));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function queryFeaturesJSON(_x2) {
        return _queryFeaturesJSON.apply(this, arguments);
      }

      return queryFeaturesJSON;
    }()
  }, {
    key: "queryFeatureCount",
    value: function queryFeatureCount(e) {
      var _this4 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.load(t).then(function () {
        return _this4._connection.invoke("queryFeatureCount", e ? e.toJSON() : null, t);
      });
    }
  }, {
    key: "queryObjectIds",
    value: function queryObjectIds(e) {
      var _this5 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.load(t).then(function () {
        return _this5._connection.invoke("queryObjectIds", e ? e.toJSON() : null, t);
      });
    }
  }, {
    key: "queryExtent",
    value: function queryExtent(e) {
      var _this6 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.load(t).then(function () {
        return _this6._connection.invoke("queryExtent", e ? e.toJSON() : null, t);
      }).then(function (e) {
        return {
          count: e.count,
          extent: j.fromJSON(e.extent)
        };
      });
    }
  }, {
    key: "querySnapping",
    value: function querySnapping(e) {
      var _this7 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.load(t).then(function () {
        return _this7._connection.invoke("querySnapping", e, t);
      });
    }
  }, {
    key: "_applyEdits",
    value: function () {
      var _applyEdits2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
        var t, r, o, i, n, _iterator2, _step2, _s, _e2, a, _iterator3, _step3, _s2, _e3, _yield$this$_connecti, l, u;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this._connection) {
                  _context3.next = 2;
                  break;
                }

                throw new s("feature-layer-source:edit-failure", "Memory source not loaded");

              case 2:
                t = this.layer.objectIdField;
                r = null;
                o = [], i = [];
                _context3.next = 7;
                return Promise.all([this._prepareClientMapping(e.addFeatures, null), this._prepareClientMapping(e.updateFeatures, null)]);

              case 7:
                n = function n(e) {
                  return "objectId" in e && null != e.objectId ? e.objectId : "attributes" in e && null != e.attributes[t] ? e.attributes[t] : null;
                };

                if (e.addFeatures && (r = this._prepareAddFeatures(e.addFeatures)), e.deleteFeatures) {
                  _iterator2 = _createForOfIteratorHelper(e.deleteFeatures);

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      _s = _step2.value;
                      _e2 = n(_s);
                      null != _e2 && o.push(_e2);
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                }

                a = e.updateFeatures && this._idToClientGraphic ? new Map() : null;

                if (e.updateFeatures) {
                  _iterator3 = _createForOfIteratorHelper(e.updateFeatures);

                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      _s2 = _step3.value;

                      if (i.push(this._serializeFeature(_s2)), a) {
                        _e3 = n(_s2);
                        null != _e3 && a.set(_e3, _s2);
                      }
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                }

                f(r ? r.features : null, i, this.layer.spatialReference);
                _context3.next = 14;
                return this._connection.invoke("applyEdits", {
                  adds: r ? r.features : [],
                  updates: i,
                  deletes: o
                });

              case 14:
                _yield$this$_connecti = _context3.sent;
                l = _yield$this$_connecti.fullExtent;
                u = _yield$this$_connecti.featureEditResults;
                return _context3.abrupt("return", (this.fullExtent = l, r && r.finish(u.uidToObjectId), this._updateClientGraphicIds(a, u), this._createEditsResult(u)));

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _applyEdits(_x3) {
        return _applyEdits2.apply(this, arguments);
      }

      return _applyEdits;
    }()
  }, {
    key: "_prepareClientMapping",
    value: function () {
      var _prepareClientMapping2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, t) {
        var r, _iterator4, _step4, _s3;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!("mesh" !== this.layerOrSourceGeometryType || u(e))) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                r = [];
                _iterator4 = _createForOfIteratorHelper(e);

                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    _s3 = _step4.value.geometry;
                    !l(_s3) || "mesh" !== _s3.type || _s3.hasExtent || _s3.loaded || r.push(_s3.load({
                      signal: t
                    }));
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }

                _context4.t0 = r.length;

                if (!_context4.t0) {
                  _context4.next = 9;
                  break;
                }

                _context4.next = 9;
                return Promise.all(r);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _prepareClientMapping(_x4, _x5) {
        return _prepareClientMapping2.apply(this, arguments);
      }

      return _prepareClientMapping;
    }()
  }, {
    key: "_updateClientGraphicIds",
    value: function _updateClientGraphicIds(e, t) {
      if (this._idToClientGraphic) {
        if (e) {
          var _iterator5 = _createForOfIteratorHelper(t.updateResults),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _r = _step5.value;
              if (!_r.success) continue;

              var _t2 = e.get(_r.objectId);

              null != _t2 && this._addIdToClientGraphic(_t2);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }

        var _iterator6 = _createForOfIteratorHelper(t.deleteResults),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _e4 = _step6.value;
            _e4.success && this._idToClientGraphic.delete(_e4.objectId);
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    }
  }, {
    key: "_createEditsResult",
    value: function _createEditsResult(e) {
      return {
        addFeatureResults: e.addResults ? e.addResults.map(this._createFeatureEditResult, this) : [],
        updateFeatureResults: e.updateResults ? e.updateResults.map(this._createFeatureEditResult, this) : [],
        deleteFeatureResults: e.deleteResults ? e.deleteResults.map(this._createFeatureEditResult, this) : [],
        addAttachmentResults: [],
        updateAttachmentResults: [],
        deleteAttachmentResults: []
      };
    }
  }, {
    key: "_createFeatureEditResult",
    value: function _createFeatureEditResult(e) {
      var t = !0 === e.success ? null : e.error || {
        code: void 0,
        description: void 0
      };
      return {
        objectId: e.objectId,
        globalId: e.globalId,
        error: t ? new s("feature-layer-source:edit-failure", t.description, {
          code: t.code
        }) : null
      };
    }
  }, {
    key: "_prepareAddFeatures",
    value: function _prepareAddFeatures(e) {
      var t = new Map(),
          r = new Array(e.length);
      var s = null;

      for (var _i2 = 0; _i2 < e.length; _i2++) {
        var _o = e[_i2],
            _n = this._serializeFeature(_o);

        !s && l(_o.geometry) && (s = _o.geometry.type), r[_i2] = _n, t.set("".concat(_n.uid), _o);
      }

      var o = this;
      return {
        features: r,
        inferredGeometryType: s,
        finish: function finish(e) {
          var r = o.sourceJSON.objectIdField;

          for (var _s4 in e) {
            var _i3 = e[_s4],
                _n2 = t.get(_s4);

            _n2 && (_n2.attributes || (_n2.attributes = {}), -1 === _i3 ? delete _n2.attributes[r] : _n2.attributes[r] = _i3, o._addIdToClientGraphic(_n2));
          }
        }
      };
    }
  }, {
    key: "_addIdToClientGraphic",
    value: function _addIdToClientGraphic(e) {
      if (!this._idToClientGraphic) return;
      var t = this.sourceJSON.objectIdField,
          r = e.attributes && e.attributes[t];
      null != r && this._idToClientGraphic.set(r, e);
    }
  }, {
    key: "layerOrSourceGeometryType",
    get: function get() {
      var e, t, r;
      return null != (e = null == (t = this.layer) ? void 0 : t.geometryType) ? e : null == (r = this.sourceJSON) ? void 0 : r.geometryType;
    }
  }, {
    key: "_requiresClientGraphicMapping",
    value: function _requiresClientGraphicMapping() {
      return this._geometryTypeRequiresClientGraphicMapping(this.layerOrSourceGeometryType);
    }
  }, {
    key: "_geometryRequiresClientGraphicMapping",
    value: function _geometryRequiresClientGraphicMapping(e) {
      return this._geometryTypeRequiresClientGraphicMapping(e.type);
    }
  }, {
    key: "_geometryTypeRequiresClientGraphicMapping",
    value: function _geometryTypeRequiresClientGraphicMapping(e) {
      return "mesh" === e || "multipatch" === e || "extent" === e;
    }
  }, {
    key: "_serializeFeature",
    value: function _serializeFeature(e) {
      var t = e.attributes,
          r = this._geometryForSerialization(e),
          s = (T++).toString();

      return r ? {
        uid: s,
        geometry: r.toJSON(),
        attributes: t
      } : {
        uid: s,
        attributes: t
      };
    }
  }, {
    key: "_geometryForSerialization",
    value: function _geometryForSerialization(e) {
      var t = e.geometry;
      if (u(t)) return null;

      if (this._geometryRequiresClientGraphicMapping(t)) {
        return t.extent ? S.fromExtent(t.extent) : null;
      }

      return t;
    }
  }, {
    key: "_startWorker",
    value: function () {
      var _startWorker2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e) {
        var _this$layer, t, r, s, o, n, a, l, u, p, d, _iterator7, _step7, _i4, h;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return c("MemorySourceWorker", {
                  strategy: i("feature-layers-workers") ? "dedicated" : "local",
                  signal: e
                });

              case 2:
                this._connection = _context5.sent;
                _this$layer = this.layer, t = _this$layer.fields, r = _this$layer.spatialReference, s = _this$layer.objectIdField, o = _this$layer.hasM, n = _this$layer.hasZ, a = _this$layer.timeInfo, l = "defaults" === this.layer.originOf("spatialReference");
                _context5.next = 6;
                return this._prepareClientMapping(this.items, e);

              case 6:
                u = this._prepareAddFeatures(this.items);
                this.handles.add(this.on("before-changes", function (e) {
                  F.error("Source modifications will not propagate after layer has been loaded. Please use .applyEdits() instead"), e.preventDefault();
                }));
                p = {
                  features: u.features,
                  fields: t && t.map(function (e) {
                    return e.toJSON();
                  }),
                  geometryType: b.toJSON(this.workerGeometryType),
                  hasM: "mesh" !== this.layerOrSourceGeometryType && o,
                  hasZ: "mesh" === this.layerOrSourceGeometryType || n,
                  objectIdField: s,
                  spatialReference: l ? null : r && r.toJSON(),
                  timeInfo: a ? a.toJSON() : null
                };
                _context5.next = 11;
                return this._connection.invoke("load", p, {
                  signal: e
                });

              case 11:
                d = _context5.sent;
                _iterator7 = _createForOfIteratorHelper(d.warnings);

                try {
                  for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                    _i4 = _step7.value;
                    F.warn(_i4.message, {
                      layer: this.layer,
                      warning: _i4
                    });
                  }
                } catch (err) {
                  _iterator7.e(err);
                } finally {
                  _iterator7.f();
                }

                d.featureErrors.length && F.warn("Encountered ".concat(d.featureErrors.length, " validation errors while loading features"), d.featureErrors);
                h = d.layerDefinition;
                this._geometryTypeRequiresClientGraphicMapping(u.inferredGeometryType) && (h.geometryType = b.toJSON(u.inferredGeometryType)), this.sourceJSON = h, this._requiresClientGraphicMapping() && (this._idToClientGraphic = new Map()), u.finish(d.assignedObjectIds);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _startWorker(_x6) {
        return _startWorker2.apply(this, arguments);
      }

      return _startWorker;
    }()
  }]);

  return G;
}(n.LoadableMixin(p(o(r))));

e([y({
  Type: t,
  ensureType: h(t)
})], G.prototype, "itemType", void 0), e([d()], G.prototype, "type", void 0), e([d({
  constructOnly: !0
})], G.prototype, "layer", void 0), e([d({
  readOnly: !0
})], G.prototype, "workerGeometryType", null), e([d()], G.prototype, "sourceJSON", void 0), G = e([m("esri.layers.graphics.sources.MemorySource")], G);
var R = G;
export { G as MemorySource, R as default };